import { render, staticRenderFns } from "./consult_index.vue?vue&type=template&id=3628307f&"
import script from "./consult_index.vue?vue&type=script&lang=js&"
export * from "./consult_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports